module.exports = __webpack_public_path__ + "static/media/local_dining.a057131f.svg";